export enum DimensionUnit {
	MILLIMETER = 'mm',
	CENTIMETER = 'cm',
	METER = 'm',
	INCH = 'in',
	FOOT = 'ft',
}

/** Display labels for each DimensionUnit value */
export const DimensionUnitLabels: Record<DimensionUnit, string> = {
	[DimensionUnit.MILLIMETER]: 'Millimeters',
	[DimensionUnit.CENTIMETER]: 'Centimeters',
	[DimensionUnit.METER]: 'Meters',
	[DimensionUnit.INCH]: 'Inches',
	[DimensionUnit.FOOT]: 'Feet',
};

/** Get the display label for a DimensionUnit value, falling back to the raw value or empty string */
export function getDimensionUnitLabel(unit: string | null | undefined): string {
	if (unit == null) return '';
	return DimensionUnitLabels[unit as DimensionUnit] ?? unit;
}

/** Pre-built options array for Select dropdowns */
export const DIMENSION_UNIT_OPTIONS: Array<{
	value: DimensionUnit;
	label: string;
}> = Object.values(DimensionUnit).map((value) => ({
	value,
	label: DimensionUnitLabels[value],
}));
